
// Trim <title> Tag
// ==============================

document.title = document.title.trim();


// Update SA Review Widget
// ==============================

setTimeout(function() {
  $('#sa-main .SA__h1').text('4.9');
}, 2500);

setTimeout(function() {
  $('#sa-main .SA__h3').text('97%');
}, 2500);


// Sitelinks Scroll
// ==============================

var url = window.location.href;

if (url.indexOf('rid=compare-fabrics') > -1) {
  setTimeout(function() {
    $('html, body').animate({
      scrollTop: $('#compare-fabrics').offset().top
    }, 1000);
  }, 2000);
}

if (url.indexOf('rid=shop-by-type') > -1) {
  setTimeout(function() {
    $('html, body').animate({
      scrollTop: $('#shop-by-type').offset().top + 15
    }, 1250);
  }, 2000);
}

if (url.indexOf('rid=verified-reviews') > -1) {
  setTimeout(function() {
    $('html, body').animate({
      scrollTop: $('#verified-reviews').offset().top + 30
    }, 1500);
  }, 2000);
}

if (url.indexOf('rid=company-reviews') > -1) {
  setTimeout(function() {
    $('html, body').animate({
      scrollTop: $('#review-header-container').offset().top - 10
    }, 1500);
  }, 2000);
}

if (url.indexOf('rid=top-categories') > -1) {
  setTimeout(function() {
    $('html, body').animate({
      scrollTop: $('#top-categories').offset().top + 10
    }, 750);
  }, 2000);
}


// Query String Parameters
// ==============================

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);


// Update Featured Products (Separate)
// ==============================

const wfp_value = urlParams.get('wfp');
let wfp_value_cat = "";
let wfp_value_model = "";
if (wfp_value && wfp_value.length > 0) {
  const wfp_parts = wfp_value.split('-');
  wfp_value_cat = wfp_parts[0];
  wfp_value_model = wfp_parts.slice(1).join('-');
  const wfp_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Platinum"]');
  const wfp_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® PLATINUM"]');  
  if (wfp_targetImg) {
    let wfp_currentSrc = wfp_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfp_modifiedSrc = wfp_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wfp_value_cat}`).replace(/(\.[^.]+)?$/, `_${wfp_value_model}.jpg`);
    let wfp_modifiedSrcThumb = wfp_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfp_targetImg.src = wfp_modifiedSrc;
    wfp_targetImgThumb.src = wfp_modifiedSrcThumb;
  }
}

const wfg_value = urlParams.get('wfg');
let wfg_value_cat = "";
let wfg_value_model = "";
if (wfg_value && wfg_value.length > 0) {
  const wfg_parts = wfg_value.split('-');
  wfg_value_cat = wfg_parts[0];
  wfg_value_model = wfg_parts.slice(1).join('-');
  const wfg_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Gold"]');
  const wfg_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® GOLD"]');  
  if (wfg_targetImg) {
    let wfg_currentSrc = wfg_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfg_modifiedSrc = wfg_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wfg_value_cat}`).replace(/(\.[^.]+)?$/, `_${wfg_value_model}.jpg`);
    let wfg_modifiedSrcThumb = wfg_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfg_targetImg.src = wfg_modifiedSrc;
    wfg_targetImgThumb.src = wfg_modifiedSrcThumb;
  }
}

const sol_value = urlParams.get('sol');
let sol_value_cat = "";
let sol_value_model = "";
if (sol_value && sol_value.length > 0) {
  const sol_parts = sol_value.split('-');
  sol_value_cat = sol_parts[0];
  sol_value_model = sol_parts.slice(1).join('-');
  const sol_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Solar-X"]');
  const sol_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® SOLAR-X"]');  
  if (sol_targetImg) {
    let sol_currentSrc = sol_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let sol_modifiedSrc = sol_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${sol_value_cat}`).replace(/(\.[^.]+)?$/, `_${sol_value_model}.jpg`);
    let sol_modifiedSrcThumb = sol_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    sol_targetImg.src = sol_modifiedSrc;
    sol_targetImgThumb.src = sol_modifiedSrcThumb;
  }
}

const wfb_value = urlParams.get('wfb');
let wfb_value_cat = "";
let wfb_value_model = "";
if (wfb_value && wfb_value.length > 0) {
  const wfb_parts = wfb_value.split('-');
  wfb_value_cat = wfb_parts[0];
  wfb_value_model = wfb_parts.slice(1).join('-');
  const wfb_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Basic"]');
  const wfb_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® BASIC"]');  
  if (wfb_targetImg) {
    let wfb_currentSrc = wfb_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfb_modifiedSrc = wfb_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wfb_value_cat}`).replace(/(\.[^.]+)?$/, `_${wfb_value_model}.jpg`);
    let wfb_modifiedSrcThumb = wfb_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfb_targetImg.src = wfb_modifiedSrc;
    wfb_targetImgThumb.src = wfb_modifiedSrcThumb;
  }
}


// Update Featured Products (All)
// ==============================

const wf_value = urlParams.get('wf');
if (wf_value && wf_value.length > 0) {
  const wf_parts = wf_value.split('-');
  wf_value_cat = wf_parts[0];
  wf_value_model = wf_parts.slice(1).join('-');
  const wfp_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Platinum"]');
  const wfp_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® PLATINUM"]');
  const wfg_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Gold"]');
  const wfg_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® GOLD"]');
  const sol_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Solar-X"]');
  const sol_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® SOLAR-X"]');
  const wfb_targetImg = document.querySelector('#compare-fabrics .custom-main-product-media img[data-fabric="WeatherFit® Basic"]');
  const wfb_targetImgThumb = document.querySelector('#compare-fabrics .custom-featured-category-slider img[alt="WF® BASIC"]'); 
  if (wfp_targetImg) {
    let wfp_currentSrc = wfp_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfp_modifiedSrc = wfp_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wf_value_cat}`).replace(/(\.[^.]+)?$/, `_${wf_value_model}.jpg`);
    let wfp_modifiedSrcThumb = wfp_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfp_targetImg.src = wfp_modifiedSrc;
    wfp_targetImgThumb.src = wfp_modifiedSrcThumb;
  }
  if (wfg_targetImg) {
    let wfg_currentSrc = wfg_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfg_modifiedSrc = wfg_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wf_value_cat}`).replace(/(\.[^.]+)?$/, `_${wf_value_model}.jpg`);
    let wfg_modifiedSrcThumb = wfg_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfg_targetImg.src = wfg_modifiedSrc;
    wfg_targetImgThumb.src = wfg_modifiedSrcThumb;
  }
  if (sol_targetImg) {
    let sol_currentSrc = sol_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let sol_modifiedSrc = sol_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wf_value_cat}`).replace(/(\.[^.]+)?$/, `_${wf_value_model}.jpg`);
    let sol_modifiedSrcThumb = sol_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    sol_targetImg.src = sol_modifiedSrc;
    sol_targetImgThumb.src = sol_modifiedSrcThumb;
  }
  if (wfb_targetImg) {
    let wfb_currentSrc = wfb_targetImg.getAttribute('src').split('?')[0].replace(/_[^.]+(\.[^.]+)$/, '$1')
    let wfb_modifiedSrc = wfb_currentSrc.replace(/(?:model-img|product-img)-(car|suv|truck|van)/, `model-img-${wf_value_cat}`).replace(/(\.[^.]+)?$/, `_${wf_value_model}.jpg`);
    let wfb_modifiedSrcThumb = wfb_modifiedSrc.replace('-swatch_', '_').replace(/(\.jpg)$/i, '_tiny$1');
    wfb_targetImg.src = wfb_modifiedSrc;
    wfb_targetImgThumb.src = wfb_modifiedSrcThumb;
  }
}


// Update MC Products
// ==============================

const mc_img = urlParams.get('mc-img');
if (mc_img && mc_img.length > 0) {
  const mc_main1 = document.querySelector(".product__media-gallery .main-slider .swiper-wrapper > div[data-index='1'] img.pr-img");
  const mc_main2 = document.querySelector("#product-gallery .main-slider .swiper-wrapper > div[data-index='2'] img.pr-img");
  const mc_thumb1 = document.querySelector("#product-gallery .thumb-slider .swiper-wrapper > div[data-index='1'] .thumb-img img");
  const mc_thumb2 = document.querySelector("#product-gallery .thumb-slider .swiper-wrapper > div[data-index='2'] .thumb-img img");  
  if (mc_main1) {
    let mc_main1_old = mc_main1.getAttribute("src");
    const mc_main1_old_idx = mc_main1_old.indexOf('_');
    let extension = "";
    if (mc_main1_old_idx !== -1) {
      const idxDot = mc_main1_old.indexOf('.', mc_main1_old_idx);
      if (idxDot !== -1) {
        const idxQuery = mc_main1_old.indexOf('?', idxDot);
        if (idxQuery !== -1) {
          extension = mc_main1_old.substring(idxDot, idxQuery);
        } else {
          extension = mc_main1_old.substring(idxDot);
        }
      }
    }
    const mc_main1_new = mc_main1_old.substring(0, mc_main1_old_idx + 1) + mc_img + "_weather" + extension;
    mc_main1.src = mc_main1_new;  
  }
  if (mc_main2) {
    let mc_main2_old = mc_main2.getAttribute("src");
    const mc_main2_old_idx = mc_main2_old.indexOf('_');
    let extension = "";
    if (mc_main2_old_idx !== -1) {
      const idxDot = mc_main2_old.indexOf('.', mc_main2_old_idx);
      if (idxDot !== -1) {
        const idxQuery = mc_main2_old.indexOf('?', idxDot);
        if (idxQuery !== -1) {
          extension = mc_main2_old.substring(idxDot, idxQuery);
        } else {
          extension = mc_main2_old.substring(idxDot);
        }
      }
    }
    const mc_main2_new = mc_main2_old.substring(0, mc_main2_old_idx + 1) + mc_img + extension;
    mc_main2.src = mc_main2_new;  
  }
  if (mc_thumb1) {
    let mc_thumb1_old = mc_thumb1.getAttribute("src");
    const mc_thumb1_old_idx = mc_thumb1_old.indexOf('_');
    let extension = "";
    if (mc_thumb1_old_idx !== -1) {
      const idxDot = mc_thumb1_old.indexOf('.', mc_thumb1_old_idx);
      if (idxDot !== -1) {
        const idxQuery = mc_thumb1_old.indexOf('?', idxDot);
        if (idxQuery !== -1) {
          extension = mc_thumb1_old.substring(idxDot, idxQuery);
        } else {
          extension = mc_thumb1_old.substring(idxDot);
        }
      }
    }
    const mc_thumb1_new = mc_thumb1_old.substring(0, mc_thumb1_old_idx + 1) + mc_img + "_weather" + "_300x" + extension;
    mc_thumb1.src = mc_thumb1_new;  
  }
  if (mc_thumb2) {
    let mc_thumb2_old = mc_thumb2.getAttribute("src");
    const mc_thumb2_old_idx = mc_thumb2_old.indexOf('_');
    let extension = "";
    if (mc_thumb2_old_idx !== -1) {
      const idxDot = mc_thumb2_old.indexOf('.', mc_thumb2_old_idx);
      if (idxDot !== -1) {
        const idxQuery = mc_thumb2_old.indexOf('?', idxDot);
        if (idxQuery !== -1) {
          extension = mc_thumb2_old.substring(idxDot, idxQuery);
        } else {
          extension = mc_thumb2_old.substring(idxDot);
        }
      }
    }
    const mc_thumb2_new = mc_thumb2_old.substring(0, mc_thumb2_old_idx + 1) + mc_img + "_300x" + extension;
    mc_thumb2.src = mc_thumb2_new;  
  }
}

const color = urlParams.get('color');
if (color) {
  const colorInputSelector = `#variantblockcontainer .product-form__input input[name="Color"][value="${color}"]`;
  const colorInput = document.querySelector(colorInputSelector);
  if (colorInput) {
    let label = colorInput.nextElementSibling;
    while (label && label.tagName.toLowerCase() !== 'label') {
      label = label.nextElementSibling;
    }
    if (label) {
      setTimeout(() => {
        label.click();
      }, 500);
    }
  }
}

const mc_kw = urlParams.get('mc-kw');
if (mc_kw && mc_kw.length > 0) {
  const heading = document.querySelector('h1');
  if (heading) {
    const originalText = heading.textContent.trim();
    heading.textContent = `${originalText} (${mc_kw})`;
  }
}


// Google Shopping (Verify Your Model)
// ==============================

const group = urlParams.get('group');
const make = urlParams.get('_make');
const model = urlParams.get('_model');
const year = urlParams.get('_year');
const category = urlParams.get('mc-cat');
const verifyModelMobile = document.getElementById('verify-model-mobile');
const verifyModel = document.getElementById('verify-model');

/*
if ((group === 'ymm' || group === 'mm') && make && model) {
  verifyModelMobile.innerHTML = `Verify <strong>${make}</strong> <strong>${model}</strong> Model`;
  verifyModel.innerHTML = `Verify <strong>${make}</strong> <strong>${model}</strong> Model`;
} else if (group === 'makes' && make) {
  verifyModelMobile.innerHTML = `Verify Your <strong>${make}</strong> Model`;
  verifyModel.innerHTML = `Verify Your <strong>${make}</strong> Model`;
}
*/

if ((group === 'ymm' || group === 'mm' || group === 'makes') && make) {
  verifyModelMobile.innerHTML = `Verify Your <strong>${make}</strong> Model`;
  verifyModel.innerHTML = `Verify Your <strong>${make}</strong> Model`;
} else if (group === 'mf' && category) {
  verifyModelMobile.innerHTML = `Verify Your <strong>${category}</strong> Model`;
  verifyModel.innerHTML = `Verify Your <strong>${category}</strong> Model`;
}


// Info Bar (Sticky)
// ==============================

const infoBar = document.getElementById('info-bar');
const infoCloseBtn = document.getElementById('close-info-bar');

infoCloseBtn.addEventListener('click', () => {
  infoBar.classList.add('not-sticky');
  sessionStorage.setItem('infoBarNotSticky', 'true');
});

if (sessionStorage.getItem('infoBarNotSticky') === 'true') {
  infoBar.classList.add('not-sticky');
}


// Update WATER/HAIL for WFP
// ==============================

setTimeout(() => {
  document.querySelectorAll('.custom-product-card.weatherfit-platinum').forEach(card => {
    const progressSection = card.querySelector('.custom-product-item-progress-main');
    if (progressSection) {
      const labels = progressSection.querySelectorAll('.progress-bar-label span');
      labels.forEach(label => {
        if (label.textContent.trim() === 'WATER') {
          label.textContent = 'WATER/HAIL';
        }
      });
    }
  });
}, 500);

setTimeout(() => {
  document.querySelectorAll('.product-view.auto-wfit-platinum .main-product-ratings').forEach(card => {
    const progressSection = card.querySelector('.custom-product-item-progress-main');
    if (progressSection) {
      const labels = progressSection.querySelectorAll('.progress-bar-label span');
      labels.forEach(label => {
        if (label.textContent.trim() === 'WATER') {
          label.textContent = 'WATER/HAIL';
        }
      });
    }
  });
}, 500);

setTimeout(() => {
  document.querySelectorAll('.product-view.power-wfit-platinum .main-product-ratings').forEach(card => {
    const progressSection = card.querySelector('.custom-product-item-progress-main');
    if (progressSection) {
      const labels = progressSection.querySelectorAll('.progress-bar-label span');
      labels.forEach(label => {
        if (label.textContent.trim() === 'WATER') {
          label.textContent = 'WATER/HAIL';
        }
      });
    }
  });
}, 500);

(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;  
  function fireQueryChangeEvent() {window.dispatchEvent(new Event('querystringchange'));}
  history.pushState = function(...args) {originalPushState.apply(this, args);fireQueryChangeEvent();};
  history.replaceState = function(...args) {originalReplaceState.apply(this, args);fireQueryChangeEvent();};
  window.addEventListener('querystringchange', () => {runPlatinumLabelUpdate();});
})();

function runPlatinumLabelUpdate() {
  setTimeout(() => {
    document.querySelectorAll('.custom-product-card.weatherfit-platinum').forEach(card => {
      const progressSection = card.querySelector('.custom-product-item-progress-main');
      if (progressSection) {
        const labels = progressSection.querySelectorAll('.progress-bar-label span');
        labels.forEach(label => {
          if (label.textContent.trim() === 'WATER') {
            label.textContent = 'WATER/HAIL';
          }
        });
      }
    });
  }, 2000);
}


// Show Covercraft Outdoor
// ==============================

/*
const showParam = urlParams.get('show');
if (showParam && showParam.length > 0) {
  setTimeout(() => {
  const wrapper = document.querySelector('.custom-product-item-container');
  if (wrapper) {
    wrapper.classList.add(`show-${showParam.toLowerCase()}`);
  }
  }, 1500);
}
*/

// Arrives by xx/xx 
// Product Page [Desktop]
// ==============================

var list = document.querySelector('.product-notes-content ul');
var listItems = list.querySelectorAll('li');

listItems.forEach(function(li) {
  if (li.textContent.includes('Guaranteed FREE 3-day delivery')) {
    li.innerHTML += '<strong class="arrives">Arrives by 12/26</strong>';
  }
});

var newLi = document.createElement('li');
newLi.innerHTML = 'Extended Holiday Returns until <strong>February 15th</strong>';
list.appendChild(newLi);


// Arrives by xx/xx 
// Product Page [Mobile]
// ==============================

const ulElement = document.querySelector('.main-product-notes ul');

const targetLi = Array.from(ulElement.children).find(li => 
  li.innerHTML.includes('Guaranteed <strong>FREE</strong> 3-day delivery')
);

if (targetLi) {
  const newLi = document.createElement('li');
  newLi.innerHTML = '<strong class="arrives">Arrives by 12/26</strong>';
  targetLi.insertAdjacentElement('afterend', newLi);
}

const holidayLi = document.createElement('li');
holidayLi.innerHTML = 'Extended Holiday Returns until <strong>February 15th</strong>';
ulElement.appendChild(holidayLi);
